export default {
  editForm: {
    message:
      'Combine apps for the iOS and Android platforms into one push channel. This way you can send push notifications to the clients that use these apps via the same broadcast. Integrate each app of the channel with edna Pulse.',
    label: 'Internal channel name',
    nameHint:
      'Enter the internal channel name. This name is used when setting up cascades and broadcasts.',
  },
};
